export default __webpack_public_path__ + "static/media/zodiac12.8373709f.png";